module.exports = __webpack_public_path__ + "static/media/image01.42c45954.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image01.jpg
// module id = 314
// module chunks = 0